<template>
  <div>
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-close'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="mdi-close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <div class="highlight-container daily-check-in-container px-4">
      <div class="highlight-wrapper pt-4" style="width: 100%">
        <div>{{ $t(`label.dailyCheckIn`) }}</div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="matches-box" style="overflow-x:hidden;">
          <v-img :src="`/static/image/dailyCheckIn/background-with-wording-${language}.jpg`">
            <v-row no-gutters class="fill-height">
              <v-col cols="6"></v-col>
              <v-col cols="6" class="reward-container">
                <div class="top-check-in-container">
                  <div class="coin-wallet">
                    <img loading="lazy" src="/static/image/icon/coinicon.png" alt="coin-wallet" />
                    <span>{{ isLoggedIn && memberInfo.rewardBalance ? memberInfo.rewardBalance : 0 }}</span>
                  </div>
                  <div class="coin-rewards">
                    <div class="coin-reward" v-for="(r, index) in dailyRewards" :key="index">
                      <span>{{ r.coins }}</span>
                      <img :src="getCoinsImg(r)" alt="coin" />
                      <span>{{ days[r.day] }}</span>
                    </div>
                  </div>
                </div>
                <div class="bottom-check-in-container">
                  <app-button class="button-check-in" :action="this.onClickButton" :title="$t(this.isLoggedIn ? `button.checkInToday` : `button.loginNow`)"></app-button>
                </div>
              </v-col>
            </v-row>
          </v-img>
        </div>
        <div v-if="$vuetify.breakpoint.smAndDown" class="matches-box" style="overflow-x:hidden; width: 100%; padding-bottom: 0;">
          <div class="check-in-bg">
            <div class="fill-height">
              <div class="title-bg">
                <img :src="`/static/image/dailyCheckIn/title-${language}.png`" alt="title" />
              </div>
              <div class="title-bg-2">
                <span class="white-title">{{ $t(`label.dailyCheckInTitle1`) }}</span>
                <span class="yellow-title">{{ $t(`label.dailyCheckInTitle2`) }}</span>
                <span class="white-title">{{ $t(`label.dailyCheckInTitle3`) }}</span>
                <span class="yellow-title">{{ $t(`label.dailyCheckInTitle4`) }}</span>
              </div>
              <div class="reward-container">
                <div class="top-check-in-container">
                  <div class="coin-wallet">
                    <img loading="lazy" src="/static/image/icon/coinicon.png" alt="coin-wallet" />
                    <span>{{ isLoggedIn && memberInfo.rewardBalance ? memberInfo.rewardBalance : 0 }}</span>
                  </div>
                  <div class="coin-rewards">
                    <div class="coin-reward" v-for="(r, index) in dailyRewards" :key="index">
                      <span>{{ r.coins }}</span>
                      <img :src="getCoinsImg(r)" alt="coin" />
                      <span>{{ days[r.day] }}</span>
                    </div>
                  </div>
                </div>
                <div class="bottom-check-in-container">
                  <app-button class="button-check-in" :action="this.onClickButton" :title="$t(this.isLoggedIn ? `button.checkInToday` : `button.loginNow`)"></app-button>
                </div>
              </div>
              <div class="play-safe-title">
                <span>{{ $t(`label.dailyCheckPlaySafe`) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-dialog :dialogShow="directToWOFDialogShow" ref="directToWOFDialog" :max-width="400" :title="$t(`label.coinsRewards`)" :closeAction="this.closeDirectToWOFDialogShow">
      <app-coin-rewards :closeDirectToWOFDialogShow="closeDirectToWOFDialogShow"></app-coin-rewards>
    </app-dialog>
  </div>
</template>

<script>
import { errorCodeHelper, locale, uiHelper } from '@/util'
import { REWARD_GET_CHECK_IN_DAY, REWARD_GET_DAILY_CHECK_IN_PRIZE_LIST, REWARD_POST_CHECK_IN_DAY, REWARD_RESET_POST_CHECK_IN_DAY } from '@/store/reward.module'
import { DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
import { MEMBER_DETAIL } from '@/store/member.module'
import AppCoinRewards from '@/components/member/coinRewards.vue'

export default {
  name: 'DailyCheckInHomeBanner',
  components: { AppCoinRewards },
  data: () => ({
    directToWOFDialogShow: false,
    dailyRewardsDialogShow: false,
    dailyRewards: [],
    days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
    dayOfWeekNumber: new Date().getDay(),
    language: uiHelper.getLanguage().toLowerCase(),
    alertShow: false,
    alertSuccess: false,
    alertMessage: ''
  }),
  created() {
    this.getDailyCheckInPrizeList()
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    rewardCheckInDay() {
      return this.$store.state.reward.checkInDay
    },
    checkInDayResponse() {
      return this.$store.state.reward.checkInDayResponse.complete
    },
    dailyCheckInPrizeList() {
      return this.$store.state.reward.dailyCheckInPrizeList
    },
    memberInfo() {
      return this.$store.state.member.info
    }
  },
  watch: {
    dailyCheckInPrizeList() {
      this.dailyRewards = this.$store.state.reward.dailyCheckInPrizeList[0].daily_coins_given
    },
    checkInDayResponse() {
      if (this.$store.state.reward.checkInDayResponse.complete) {
        this.checkInComplete(this.$store.state.reward.checkInDayResponse)
      }
    },
    alertShow() {
      if (!this.alertShow) {
        this.alertSuccess = ''
        this.alertMessage = ''
      }
    }
  },
  methods: {
    getMemberDetail() {
      if (this.isLoggedIn) this.$store.dispatch(`${MEMBER_DETAIL}`)
    },
    getDailyCheckInPrizeList() {
      let obj = {
        id: 2
      }
      this.$store.dispatch(`${REWARD_GET_DAILY_CHECK_IN_PRIZE_LIST}`, { obj })
    },
    getRewardCheckInDay() {
      this.$store.dispatch(`${REWARD_GET_CHECK_IN_DAY}`)
    },
    checkInDay() {
      let obj = {
        checkinDay: this.dayOfWeekNumber
      }
      this.$store.dispatch(`${REWARD_POST_CHECK_IN_DAY}`, { obj })
    },
    navigateWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      }
      this.closeDirectToWOFDialogShow()
    },
    checkInComplete(res) {
      if (res.success) {
        this.openAlert(true, locale.getMessage(`message.checkedIn`))
        this.getMemberDetail()
        this.getRewardCheckInDay()
        const coin = Number(this.memberInfo.rewardBalance) + Number(this.dailyRewards[this.dayOfWeekNumber - 1].coins)
        if (coin >= 10) {
          this.directToWOFDialogShow = true
        }
      } else {
        this.openAlert(false, errorCodeHelper.getErrorCodeDesc(res.code))
        this.getRewardCheckInDay()
      }
      this.$store.dispatch(`${REWARD_RESET_POST_CHECK_IN_DAY}`)
    },
    getCoinsImg(reward) {
      const coinImg = '/static/image/icon/coinicon.png'
      const checkedCoinImg = '/static/image/icon/checked_coin.png'
      const passedCoinImg = '/static/image/icon/passed_coin.png'
      if (this.isLoggedIn) {
        if (this.rewardCheckInDay.includes(reward.day)) {
          return checkedCoinImg
        } else {
          if (reward.day < this.dayOfWeekNumber && reward.day != 0) {
            return passedCoinImg
          } else {
            return coinImg
          }
        }
      } else {
        return coinImg
      }
    },
    openLoginDialog() {
      return this.$parent.openLoginDialog()
    },
    onClickButton() {
      if (this.isLoggedIn) {
        this.checkInDay()
      } else {
        this.openLoginDialog()
      }
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    closeDirectToWOFDialogShow() {
      this.directToWOFDialogShow = false
    }
  }
}
</script>

<style lang="scss">
.daily-check-in-container {
  max-height: 100%;

  @media (max-width: 959px) {
    padding-bottom: 12px;
  }

  .float-coin-1 {
    position: absolute;
    z-index: 1;
    bottom: 0;
    right: 0;
    width: 72px;

    @media (max-width: 500px) {
      display: none;
    }
  }

  .float-coin-2 {
    position: absolute;
    z-index: 1;
    left: 8px;
    top: 60%;
    width: 56px;

    @media (max-width: 500px) {
      display: none;
    }
  }

  .float-gift {
    position: absolute;
    z-index: 1;
    bottom: 0;
    right: 0;
    width: 56px;

    @media (max-width: 500px) {
      display: none;
    }
  }

  .check-in-bg {
    width: 100%;
    max-height: 526px;
    max-width: 100vw;
    padding: 8px 0;
    background-image: url(/static/image/dailyCheckIn/bg-m.jpg);
    background-size: cover;

    .title-bg {
      width: 100%;
      padding: 2.5% 8px;
      align-content: center;
      background-image: url(/static/image/dailyCheckIn/flag.png);
      background-size: cover;

      img {
        width: 96%;
      }
    }

    .title-bg-2 {
      width: 100%;
      padding: 2% 8px;
      background-image: linear-gradient(to right, #da4701, rgb(255, 119, 0, 0.31));

      .white-title {
        font-size: 20px;
        color: white;

        @media (max-width: 500px) {
          font-size: 16px;
        }
      }
      .yellow-title {
        font-size: 22px;
        color: yellow;

        @media (max-width: 500px) {
          font-size: 18px;
        }
      }
    }

    .play-safe-title {
      width: 100%;
      margin-top: 12px;
      text-align: center;
      font-size: 22px;
      font-style: italic;
      color: white;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
    }
  }

  .reward-container {
    width: 100%;
    height: 100%;
    align-content: center;
    padding-left: 68px !important;
    padding-right: 28px !important;

    @media (max-width: 1024px) {
      padding-left: 56px !important;
      padding-right: 12px !important;
    }

    @media (max-width: 959px) {
      width: 420px;
      height: auto;
      max-width: 98%;
      margin: 8px auto 0 !important;
      padding: 0 !important;
    }

    .top-check-in-container {
      width: 100%;
      height: 216px;
      padding: 20px 8px;
      border-top-left-radius: 30px !important;
      border-top-right-radius: 30px !important;
      border: 4px solid white;
      border-bottom: none;
      color: white;
      background-image: url(/static/image/reward/checkin.png);
      background-size: cover;

      @media (max-width: 1024px) {
        height: 200px;
        padding: 16px 4px;
      }

      @media (max-width: 500px) {
        height: 168px;
        padding: 16px 4px;
      }

      .coin-wallet {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        img {
          width: 56px;
          @media (max-width: 500px) {
            width: 48px;
          }
        }
      }

      .coin-rewards {
        display: flex;
        margin: 16px auto;
        justify-content: space-between;
        font-size: 16px;

        @media (max-width: 1024px) {
          margin: 12px auto;
        }

        @media (max-width: 500px) {
          font-size: 14px;
        }

        .coin-reward {
          display: flex;
          flex-direction: column;
          width: 14.2%;
          gap: 6px;
          align-items: center;

          @media (max-width: 500px) {
            gap: 2px;
          }

          img {
            width: 70px;

            @media (max-width: 500px) {
              width: 52px;
            }
          }
        }
      }
    }

    .bottom-check-in-container {
      width: 100%;
      height: 102px;
      align-content: center;
      text-align: center;
      border-bottom-left-radius: 30px !important;
      border-bottom-right-radius: 30px !important;
      border: 4px solid white;
      border-top: none;
      background: url(/static/image/reward/Purple_line.png), linear-gradient(to right, #6900b8, #0045ff);
      background-size: cover;

      @media (max-width: 1024px) {
        height: 88px;
      }

      @media (max-width: 500px) {
        height: 72px;
      }

      .button-check-in {
        width: 80%;
        height: 56px;
        font-size: 20px !important;
        border-radius: 4px;
        color: #ffffff;
        background-image: linear-gradient(to bottom, #ffab2d, #ff7700);

        @media (max-width: 1024px) {
          width: 76%;
          height: 48px;
        }

        @media (max-width: 500px) {
          font-size: 18px !important;
          height: 40px;
        }
      }
    }
  }
}
</style>
